import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { useThemeStyles } from "../../../styles/themes";
import "./MandateFailureLegacy.scss";

const MandateFailureLegacy = () => {
  const classes = useThemeStyles();
  const history = useHistory();
  const { state, actions } = useContext(StoreContext);

  const handleRetry = () => {
    // Clear URL
    history.replace(history.location.pathname);
    actions.setStep("Step8Mandate");
  };

  return (
    state.prerequisites && (
      <>
        <Header />
        <div className="page page-mandate-failure">
          <div className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}>

            <div className="body-holder">
              <div className="banner-holder">
                <img className="banner" src="/images/bank-rejected@2x.png" alt="success" />
              </div>

              <p className="text-desc">
                Your card was rejected by the bank.
                <br />
                <br />
                Please use another debit card or try again with the same card after verifying with your bank if online transactions are enabled.
              </p>
            </div>

            <div className="action-holder">
              <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={handleRetry}>
                Try Again
              </Button>
            </div>
          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(MandateFailureLegacy, {
  stepId: "MandateFailure",
  endJourneyOnStepStart: true,
});
